'use strict';

window.CFC = window.CFC || {};
window.CFC.VideoModal= (function($) {
  function init() {
    $('[data-modal-video-id]').on('click', handleVideoClick);
  }
  
  function handleVideoClick(e) {
    e.preventDefault();

    const transcriptNode = copyTranscript(e.currentTarget.closest('.card'));
    const videoHtml = '<div class="media__wrap videoBox__wrap"><div class="media__video" id="media__video--modal"></div></div>';
    const contentHtml = transcriptNode ? `<div class='descExpander__wrap'>${ videoHtml }${ transcriptNode.outerHTML }</div>` : videoHtml;
    const closeButtonHtml = CFC.Common.getModalCloseButtonHtml();
     
    const $wrap = $(`<div>${ closeButtonHtml }${ contentHtml }</div>`);
    
    const dialogClass = "dialog--modalVideo";
    const dialog = CFC.Common.createModal($wrap[0], this, null, dialogClass);

    dialog.dialogNode.addEventListener('click', function(e) {
      if (e.originalTarget.classList.contains(dialogClass)) {
        dialog.close();
      }
    });

    if (!window.YT) { return; }

    var playerOptions = window.CFC.Common.getYTPlayerOptions(this.dataset.modalVideoId);
    
    window.setTimeout(function() {
      new window.YT.Player('media__video--modal', playerOptions);
      Plaintext.DescriptionExpander.initializeWrappedTranscript(dialog.dialogNode.querySelector('.descExpander__wrap'));
    }, 1);
  }
  
  function copyTranscript(src) {
    if (!src) { return; }
    
    const transcriptNode = src.querySelector('[data-modal-video-transcript]');
    
    if (!transcriptNode) { return; }
    
    const clonedNode = transcriptNode.querySelector('.descExpander').cloneNode(true);

    // Replace ids to make sure they're unique.
    clonedNode.id = 'dialog-modalVideo__transcriptExpander'; 
    clonedNode.querySelector('.descExpander__content').id = 'dialog-modalVideo__transcriptContent'; 

    return clonedNode;
  }
  
  $(init);
})(jQuery);